const password = {
  pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&+=*(),.;:{}]).+$/,
  message: "必须包含字母、数字和符号(~!@#$%^&+=*(),.;:{})",
  trigger: "change"
};

export default {
  password
};
